import React, {useEffect, useRef} from "react";
import lottie from 'lottie-web';
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core'

const useStyles=makeStyles(()=>({

 
    animation:{
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-50px',
        marginLeft: '-50px',
        width: '100px',
        height: '100px',
    },
  
    
}))

export default function Loading(){

    const classes =useStyles();
    const container =useRef(null);

    useEffect(()=>{

        lottie.loadAnimation({
            container:container.current,
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: require('../Lotties/loading.json')
        })
    },[])


    return(
        <div>

            <Grid container>
                <Grid item xs={1} md={5}></Grid>
                <Grid item xs={10} md={2} >
                <div ref={container} className={classes.animation}></div>
                </Grid>
                <Grid item xs={1} md={5}></Grid>
            </Grid>
            
        </div>
    )
}
